// extracted by mini-css-extract-plugin
export var active = "_gu-7";
export var blink = "_gu-8";
export var dropDownSelector = "_gu-4";
export var dropDownWrapper = "_gu-3";
export var fakeCursor = "_gu-6";
export var fontSizeButton = "_gu-9";
export var formQuillEditor = "_gu-0";
export var pressed = "_gu-a";
export var qlBlank = "_gu-1";
export var textFormattingToolbar = "_gu-2";
export var textToolbarOption = "_gu-5";